import { TyTimelineProfile } from './TyTimelineProfile';
import { LifeTransactionData } from '@tymbe/schema/life-transaction.interface';
import { ReactNode } from 'react';
import { lifeTransactionTypeMap } from '@tymbe/schema/enums';
import { TyTimelineCard } from './TyTimelineCard';
import { BadgePill } from '@tymbe/ty-components/indicators';
import { FavouriteIcon } from '@tymbe/ui-icons';
import { makeInflect } from '@tymbe/utils/makeInflect';

export type TyTimelineLivesItemProps = {
  lifeTransaction: LifeTransactionData;
  action?: ReactNode;
  lastItemObserverRef: ((node: HTMLLIElement) => void) | null;
};

const getTitle = (numberOfLives: number) => {
  const absoluteLives = Math.abs(numberOfLives);
  const lives = makeInflect("život", "životy", "životů")(absoluteLives);

  let sign = numberOfLives > 0 ? '+' : '-';
  if (numberOfLives === 0) sign = '';

  return `${sign}${absoluteLives} ${lives}`;
};

export const TyTimelineLivesItem = ({
  lifeTransaction,
  action,
  lastItemObserverRef,
}: TyTimelineLivesItemProps) => {
  const isDeleted = lifeTransaction.deleted_at !== null;
  const title = getTitle(isDeleted ? 0 : lifeTransaction.value);
  const note = `[${lifeTransactionTypeMap[lifeTransaction.type]}] ${
    lifeTransaction.note ? lifeTransaction.note : 'Bez poznámky'
  }`;
  return (
    <li className="mb-10 relative flex flex-col" ref={lastItemObserverRef}>
      <div className="ml-[-58px]">
        {lifeTransaction.deleted_at && (
          <TyTimelineProfile
            date={lifeTransaction.deleted_at}
            person={lifeTransaction.deletedBy}
            showDeletedBadgePill
          />
        )}
        <TyTimelineProfile
          date={lifeTransaction.created_at}
          person={lifeTransaction.createdBy}
          variant={lifeTransaction.deleted_at ? 'deleted' : 'regular'}
        />
      </div>
      <TyTimelineCard
        action={action}
        variant={isDeleted ? 'deleted' : 'regular'}
        title={title}
        note={note}
        badgePill={
          <BadgePill
            className="flex items-center h-min w-min min-w-[110px]"
            variant={lifeTransaction.value > 0 ? 'success' : 'error'}
          >
            <FavouriteIcon name="favorite" className="size-4 mr-1" />
            Životy a bany
          </BadgePill>
        }
      />
    </li>
  );
};
